import { IS_STAGING } from '@constants';
import { Contract } from '@ethersproject/contracts';
import { JsonRpcSigner, JsonRpcProvider } from '@ethersproject/providers';
import LixiBagAbi from '../../abi/LixiBag.json';
import { NETWORKS } from '../networks';

export function getLixiBagContract(
  lixiBagAddress: string,
  library?: JsonRpcSigner,
  isWrite = false,
) {
  if (isWrite && !library) {
    throw new Error('Write contract must provide signer');
  }

  if (isWrite) {
    return new Contract(lixiBagAddress, LixiBagAbi, library);
  }

  // Use BSC RPC endpoints instead of BscscanProvider
  const bscRpcUrl =
    IS_STAGING === 'true' ? NETWORKS[97].rpc[0] : NETWORKS[56].rpc[0];
  const bscProvider = new JsonRpcProvider(bscRpcUrl);
  return new Contract(lixiBagAddress, LixiBagAbi, bscProvider);
}
